import { createIconComponent } from '../../factory/create-icon-component';
export const ChinaIcon = createIconComponent(
  'ChinaIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33691)">
      <path d="M23 5H1V20H23V5Z" fill="#D80027" />
      <path
        d="M8.68796 9.58069L9.31771 11.5629H11.3557L9.70692 12.788L10.3367 14.7703L8.68796 13.5452L7.03921 14.7703L7.66896 12.788L6.0202 11.5629H8.05817L8.68796 9.58069Z"
        fill="#FFDA44"
      />
      <path
        d="M12.6577 16.1734L12.0393 15.714L11.4211 16.1734L11.6572 15.4301L11.0389 14.9707H11.8032L12.0393 14.2273L12.2756 14.9707H13.0398L12.4215 15.4301L12.6577 16.1734Z"
        fill="#FFDA44"
      />
      <path
        d="M14.2701 13.9031H13.5059L13.2697 14.6464L13.0336 13.9031L12.2693 13.9031L12.8877 13.4436L12.6514 12.7003L13.2697 13.1597L13.888 12.7003L13.6518 13.4436L14.2701 13.9031Z"
        fill="#FFDA44"
      />
      <path
        d="M14.2701 11.0965L13.6518 11.556L13.888 12.2992L13.2697 11.8399L12.6514 12.2993L12.8877 11.5559L12.2693 11.0966L13.0336 11.0965L13.2697 10.3531L13.5059 11.0965H14.2701Z"
        fill="#FFDA44"
      />
      <path
        d="M12.6576 8.82609L12.4215 9.56946L13.0397 10.0288L12.2755 10.0289L12.0393 10.7723L11.8031 10.0288L11.0389 10.0289L11.6572 9.56942L11.4211 8.82605L12.0393 9.28549L12.6576 8.82609Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33691">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
